import {FC} from 'react'
import {uploadTemplateService} from '../../services/uploadTemplate'
import {ShowSnackBar} from '../../../../../../util/functions'
import {ERROR_MESSAGE_SYSTEM} from '../../../../../../util/Constants'
import {MasiveUploadHoteleria} from '../../../../../../components/UI/Form/MasiveHoteleria'
import {getTemplateRoomService} from '../../services'
const FormMasiveUploadRoom: FC = () => {
  const handleUpload = async (formData: FormData) => {
    try {
      const data = await uploadTemplateService(formData) // Use the service to upload the file
      return data
    } catch (error) {
      console.error('Error uploading file:', error)
      // ShowSnackBar(ERROR_MESSAGE_SYSTEM, 'error')
    }
  }

  return (
    <MasiveUploadHoteleria
      serviceTemplate={getTemplateRoomService}
      handleSendService={handleUpload}
      showModalList
      title='Habitaciones'
    />
  )
}

export {FormMasiveUploadRoom}
